/* --------------------------------------------------------------------------
  Copyright (c) 2016, VoiceVibes, Inc

  VoiceVibes, Inc - PROPRIETARY/CONFIDENTIAL
  All contents of this file are proprietary and confidential. No part of
  any of the contents of this file may be disclosed in any manner to
  a third party without the prior written consent of VoiceVibes, Inc.
  Unauthorized copying of this file, via any medium is strictly prohibited.
----------------------------------------------------------------------------- */

import service from '../../services/user';
import _ from 'lodash';

const USER_LOAD = 'USER_LOAD';
const PREFERENCES = 'PREFERENCES';
const SET_CURRENT_MODE = 'SET_CURRENT_MODE';
const USER_UPDATE_EMAIL_PREFERENCES = 'USER_UPDATE_EMAIL_PREFERENCES';

const state = {
  currentMode: null,
  user: null,
};

const mutations = {
  [USER_LOAD] (state, user) {
    state.user = user;
  },
  [SET_CURRENT_MODE] (state, mode) {
    state.currentMode = mode;
  },
  [USER_UPDATE_EMAIL_PREFERENCES] (state, emailPreferences) {
    state.user = _.merge(state.user, emailPreferences);
  }
};

const actions = {
  getUser: ({ commit }) => {
    return service.get()
      .then(user => {
        // Register the user details with Raven
        if (window.Raven) {
          window.Raven.setUserContext({
            id: user.userId,
            email: user.email
          });
        }

        commit(USER_LOAD, user);
      });
  },
  setCurrentMode: ({ commit }, mode) => {
    commit(SET_CURRENT_MODE, mode);
  },
  resetUser: ({ commit }) => {
    commit(USER_LOAD, null);
  },
  updatePreferences: ({ }, preferences) => {
    if (!state.user || !state.user.userId) {
      return;
    }

    preferences.userId = state.user.userId;
    setFromLocalStorage(PREFERENCES, preferences);
  },
  updateUser: ({ commit }, userData) => {
    let _userDataForApi = _.clone(userData);
    let _userDataForState = _.clone(userData);

    // Normalize metadata for the API
    ['gender', 'birthyear', 'title'].forEach((key) => {
      _userDataForApi[key] = _userDataForApi.metadata[key];
    });
    delete _userDataForApi.metadata;
    if (_userDataForApi.isEu !== '1') {
      delete _userDataForApi.dataRetention;
      delete _userDataForApi.dataUseAllowed;
    }

    // Normalize email fields for state
    if (_userDataForState.newEmail) {
      _userDataForState.email = _userDataForState.newEmail;
    } else {
      _userDataForState.email = _userDataForState.oldEmail;
    }
    delete _userDataForState.newEmail;
    delete _userDataForState.oldEmail;

    return service.put(_userDataForApi)
      .then(() => {
        commit(USER_LOAD, _userDataForState);
      });
  },
  updateUserEmailPreferences: ({ commit }, emailPreferences) => {
    return service.updateEmailPreferences(emailPreferences)
      .then(() => {
        commit(USER_UPDATE_EMAIL_PREFERENCES, emailPreferences);
      });
  },
};

const getters = {
  currentMode: state => state.currentMode,
  user: state => state.user,
  preferences: (state) => {
    const preferences = getFromLocalStorage(PREFERENCES);
    if (preferences && preferences.userId) {
      if (state.user && state.user.userId && state.user.userId != preferences.userId) {
        // The user changed so reset the preferences
        removeFromLocalStorage(PREFERENCES);
        return {};
      }
      return preferences;
    }

    return {};
  },
};

function getFromLocalStorage(key) {
  try {
    return JSON.parse(localStorage.getItem(key) || '');
  } catch(err) {
    return '';
  }
}

function setFromLocalStorage(key, val) {
  val = JSON.stringify(val);
  try {
    localStorage.setItem(key, val);
  } catch(err) {
    return;
  }
}

function removeFromLocalStorage(key) {
  try {
    localStorage.removeItem(key);
  } catch(err) {
    return;
  }
}

export default {
  state,
  mutations,
  actions,
  getters
};
